"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TransactionResult = /** @class */ (function () {
    function TransactionResult() {
    }
    return TransactionResult;
}());
exports.TransactionResult = TransactionResult;
//# sourceMappingURL=TransactionResult.js.map